namespace Areas.Maintenance {
    "use strict";

    var selected = new Selected();

    export function onUserIdValueChanged(rowData: any, value: any) {
        return userValueChanged(selected)(rowData, value);
    }     

    export function ondlUserIDValueChanged(rowData: any, value: any) {
        return userValueChanged(selected)(rowData, value);
    }

        export function userAuthorizedLookupEditTemplate(cellElement: any, cellInfo: any) {
            return lookupEditTemplate("/Maintenance/AuthorizedUser/Users", selected)(cellElement, cellInfo);
        }

        export function userLookupEditTemplate(cellElement: any, cellInfo: any) {
            return lookupEditTemplate("/Maintenance/SystemUsers/Users", selected)(cellElement, cellInfo);
        }

        export function dluserLookupEditTemplate(cellElement: any, cellInfo: any) {
            return lookupEditTemplateUserName("/Maintenance/DurationLimit/Users", selected)(cellElement, cellInfo);
        }

        export function userLookupCellTemplate(cellElement: any, cellInfo: any) {
            return lookupCellTemplate(cellElement, cellInfo);

        }

        export function dluserLookupCellTemplate(cellElement: any, cellInfo: any) {
            return cellElement.text(cellInfo.data.userName)
        }

        export function disableColumnEdit(columnName: string) {
            return function (e: any) {
                if (e.rowType !== "data" || !e.row.isEditing)
                    return;
                if (e.column.dataField === columnName && !e.row.isNewRow)
                    e.cellElement.find('input').prop('readonly', true);
            }
        }
    
}